import React from 'react';

interface AvatarWithProgressProps {
  avatarUrl?: string | null;
  emoji?: string;
  progress: number;
  level: number;
}

export function AvatarWithProgress({
  avatarUrl,
  emoji = '👨‍💻',
  progress,
  level,
}: AvatarWithProgressProps) {
  const normalizedProgress = Math.max(0, Math.min(100, progress));
  const isComplete = normalizedProgress >= 100;

  const gradientColors = isComplete
    ? '#fbbf24, #f59e0b, #fbbf24'
    : '#a78bfa, #7c3aed';

  const outerStyle: React.CSSProperties = {
    width: 108,
    height: 108,
    borderRadius: 28,
    background: `
      linear-gradient(#0f0a1a, #0f0a1a) padding-box,
      conic-gradient(
        ${gradientColors} 0%,
        ${isComplete ? '#fbbf24' : '#7c3aed'} ${normalizedProgress}%,
        rgba(139,92,246,0.08) ${normalizedProgress}%,
        rgba(139,92,246,0.08) 100%
      ) border-box
    `,
    border: '2.5px solid transparent',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
  };

  const imgStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    borderRadius: 25,
    objectFit: 'cover',
  };

  const placeholderStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    borderRadius: 25,
    background: 'linear-gradient(135deg, #2d1b4e, #1a0e30)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 44,
  };

  const levelStyle: React.CSSProperties = {
    position: 'absolute',
    bottom: -2,
    right: -2,
    width: 26,
    height: 26,
    borderRadius: 8,
    background: 'linear-gradient(135deg, #7c3aed, #5b21b6)',
    border: '2.5px solid #0f0a1a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
    fontWeight: 700,
    color: 'white',
    boxShadow: '0 2px 6px rgba(124,58,237,0.3)',
  };

  return (
    <div style={{ position: 'relative', width: 108, height: 108 }}>
      <div style={outerStyle}>
        {avatarUrl ? (
          <img src={avatarUrl} alt="" style={imgStyle} />
        ) : (
          <div style={placeholderStyle}>{emoji}</div>
        )}
      </div>
      <div style={levelStyle}>{level}</div>
    </div>
  );
}
